import React, { createContext } from 'react';
import http from '../utils/httpFacade';
import axios from 'axios';

export const PaymentContext = createContext();

const PaymentContextProvider = ({ children }) => {
  const initializePayment = async order => {
    try {
      return await http.post({ url: 'payment/paystack', body: JSON.stringify(order) });
    } catch (error) {
      return error.data;
    }
  };

  const verifyPayment = async reference => {
    try {
      return await http.get({ url: 'payment/paystack', query: { reference } });
    } catch (error) {
      return error.data;
    }
  };

  const convertUSDtoGHS = async amount => {
    try {
      const res = await axios.get(
        `https://data.fixer.io/api/convert?access_key=f41f33f11be22d3d5cca920c63b2f436&from=USD&to=GHS&amount=${amount}`
      );

      if (res.data.success && res.data.query.amount === amount) {
        let data = { rateUsed: res.data.info.rate, newAmount: res.data.result };
        return data;
      }
    } catch (error) {
      return error.response.data;
    }
  };

  const saveOrder = async order => {
    try {
      return await http.post({ url: 'crowd-farmer/orders', body: JSON.stringify(order) });
    } catch (error) {
      return error.data;
    }
  };

  return (
    <PaymentContext.Provider
      value={{ initializePayment, verifyPayment, convertUSDtoGHS, saveOrder }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

export default PaymentContextProvider;
